export enum PreferredEmail {
	Work = 1,
	Personal = 2
}